import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import moment from "moment";
import DateRange from "../../Components/DateRange";
import { useLocation, useNavigate } from "react-router-dom";
import { IoChevronBackOutline } from "react-icons/io5";
import { BsCalendar } from "react-icons/bs";
import { MdCategory } from "react-icons/md";

const ExpenseSummary = () => {
  const location = useLocation();
  const propId = location.state?.propId;
  const user = useSelector((state) => state.UserReducer.user);
  const navigate = useNavigate();
  const [apiData, setApiData] = useState();
  const [filter, setFilter] = useState("");
  const [filterVal, setFilterVal] = useState("");
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const fetchFunction = async () => {
    const query = `&startDate=${startDate}&endDate=${endDate}&propId=${propId}&filter=${filter}&filterVal=${filterVal}`;
    const response = await axios.get(
      `${Config.apiUrl}/expense/list/stats?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) {
      // console.error("API request failed");
    } else {
      setApiData(res?.data);
    }
  };

  const getError = (error) => {
    // console.error("API error:", error);
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);
    return () => clearTimeout(handler);
  }, [startDate, endDate]);

  const submitHandler = (values) => {
    setFilter("");
    setFilterVal("");
    setStartDate(moment(values.startDate).format("YYYY-MM-DD"));
    setEndDate(moment(values.endDate).format("YYYY-MM-DD"));
  };

  const sortedCategories = apiData?.initialValues
    ? [...apiData.initialValues].sort((a, b) => b.amount - a.amount)
    : [];

  const handleBackClick = () => {
    navigate("/finance/expenses");
  };

  const getPercentage = (amount) => {
    if (!apiData?.totalExpense) return 0;
    return ((amount / apiData.totalExpense) * 100).toFixed(1);
  };

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="whitespace-nowrap">
          <BackWrapper>
            <BackButton onClick={handleBackClick}>
              <IoChevronBackOutline size={20} />
            </BackButton>
            <div>
              <span className="flex items-center"> Expense Summary</span>
              <Underline />
            </div>
          </BackWrapper>
        </BoxTitle>

        {/* <DateRange
          submitHandler={submitHandler}
          defaultLabel={
            moment(startDate).format("DD MMM yyyy") +
            " - " +
            moment(endDate).format("DD MMM yyyy")
          }
        /> */}
      </BoxHead>

      <ContentWrapper>
        <CardWrapper>
          <Wrapper>
            <Item>
              <Label>
                Total Expenses
              </Label>
              <Value>
                ₹{Number.parseInt(apiData?.totalExpense || 0).toLocaleString()}
              </Value>
            </Item>
            <DateRange
              submitHandler={submitHandler}
              defaultLabel={
                moment(startDate).format("DD MMM yyyy") +
                " - " +
                moment(endDate).format("DD MMM yyyy")
              }
            />
          </Wrapper>
        </CardWrapper>

        {(isLoading || isRefetching) && <Loading />}

        {apiData && !isRefetching && !isLoading && (

          < EnhancedCategoriesContainer >
            {
              sortedCategories.map((category) => {
                const percentage = getPercentage(category.amount);

                return (
                  <EnhancedCategoryCard key={category.expenseCategoryId}>
                    <div>
                      <CategoryName>{category.expenseCategoryName}</CategoryName>
                      <CategoryRow>
                        <CategoryPercentage>
                          {percentage}% of total
                        </CategoryPercentage>
                        <CategoryAmount>
                          ₹{Number.parseInt(category.amount).toLocaleString()}
                        </CategoryAmount>
                      </CategoryRow>
                      <ProgressBar>
                        <ProgressFill style={{ width: `${percentage}%` }} />
                      </ProgressBar>
                    </div>
                  </EnhancedCategoryCard>
                );
              })
            }
          </EnhancedCategoriesContainer>
        )
        }
      </ContentWrapper>

    </BoxContainer >
  );
};

const BackWrapper = tw.div`flex items-center`;
const Wrapper = tw.div`flex items-center justify-between`;
const BackButton = tw.button`hover:bg-gray-200 items-center -mt-1 p-1 rounded-md transition-colors`;
const ContentWrapper = tw.div``;
const CardWrapper = tw.div`mb-8 bg-white p-4 border rounded-md`;
const CardInner = tw.div`bg-white relative overflow-hidden rounded-md p-4 text-white mb-8 border`;
const EnhancedCategoriesContainer = tw.div`grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6`;
const EnhancedCategoryCard = tw.div`p-4 rounded-md cursor-pointer relative border bg-white`;
const CategoryRow = tw.div`flex items-center justify-between mb-1`;
const CategoryName = tw.h4`font-semibold text-lg text-gray-800 mb-2`;
const CategoryPercentage = tw.p`text-sm opacity-90 text-gray-600`;
const CategoryAmount = tw.p`text-xl font-semibold text-primary-color text-right`;
const ProgressBar = tw.div`w-full bg-gray-400 bg-opacity-20 rounded-md h-2`;
const ProgressFill = tw.div`bg-gray-400 h-2 rounded-md transition-all duration-500`;

const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between whitespace-normal`
// const Value = tw.p`text-xl sm:text-2xl font-bold`
const Value = tw.p`
  text-xl sm:text-2xl font-bold text-gray-800`;
const Item = tw.div``;

export default ExpenseSummary;
